import { AnyAction } from "redux";

import {
  LOGGER_LOG,
  LOGGER_ERROR,
  LOGGER_LOGS_SEND_PENDING,
  LOGGER_LOGS_SEND_FULFILLED,
  LOGGER_LOGS_SEND_REJECTED,
} from "./constants";

export type LogRecord = {
  customerId?: string;
  siteId?: string;
  scanDate?: string;
  msg: string;
  ts: number;
};

const defaultLoggerState = {
  records: [],
  sending: [],
};
export type LoggerState = {
  records: LogRecord[];
  sending: LogRecord[];
};

export default function records(
  state: LoggerState = defaultLoggerState,
  action: AnyAction,
): LoggerState {
  switch (action.type) {
    case LOGGER_LOG:
    case LOGGER_ERROR:
      return {
        ...state,
        records: [...state.records, action.payload],
      };
    case LOGGER_LOGS_SEND_PENDING:
      return {
        ...state,
        records: [],
        sending: state.records,
      };
    case LOGGER_LOGS_SEND_FULFILLED:
      return {
        ...state,
        sending: [],
      };
    case LOGGER_LOGS_SEND_REJECTED:
      return {
        ...state,
        records: [...state.records, ...state.sending],
        sending: [],
      };
    default:
      return state;
  }
}
